import { PipeTransform, Pipe } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'formatAnoMes',
})
export class FormatAnoMes implements PipeTransform {
  transform(anoMes: number | number[] | undefined, format:string = 'MMMM'): string {
    if(!anoMes){
      return '';
    }

    if(Array.isArray(anoMes)){
      if(anoMes.length === 0) {
        return '';
      }

      if(anoMes.length === 1) {
        return this.getAnoMesFormatted(anoMes[0], format)
      }

      const dateFormatted = this.getAnoMesFormatted(anoMes[0], format);
      const dateFormattedFinal = this.getAnoMesFormatted(anoMes[anoMes.length-1], format);

      if(dateFormatted === dateFormattedFinal){
        return dateFormatted;
      }

      return `${dateFormatted} - ${dateFormattedFinal}`;
    }

    return this.getAnoMesFormatted(anoMes, format)
  }

  private getAnoMesFormatted(anoMes: number, format: string){
    const date = moment().locale('pt-br');

    const anoMesStr = String(anoMes);

    date.year(Number(anoMesStr.substring(0, 4)))
    date.month(Number(anoMesStr.substring(4)) - 1)

    console.log("date", date)

    return date.format(format);
  }
}
